/* eslint-disable react/jsx-max-depth */
import React, { useEffect, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Modal, Text } from '@mantine/core';
import LoginForm from '../../components/forms/Login';
import styles from './styles.scoped.css';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RECAPTCHA_KEY } from '../../../env';
import { ToastrContext } from '../../contexts';
import ModalForgotPassword from '../../components/fragments/ModalForgotPassword';
import ModalReminderResetPassword from '../../components/fragments/ModalReminderResetPassword';
import { clearError, fetchPasswordExpired } from '../ResetPassword/actions';
import LogoMap from '../../components/icons/logo';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ModalPasswordExpired from '../../components/fragments/ModalPasswordExpired';
import { getToken, setOAuthState, setCodeVerifier } from '../../utils/storage';
import { generateCodeVerifier, generateCodeChallenge, generateState } from '../../utils/pkce';
import { buildAuthorizeUrl } from '../../utils/idaman';
import { login, clearError as clearErrorLogin, loginOauthIdaman } from './actions';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  const [openReminder, setOpenReminder] = useState(false);
  const { setToastr } = useContext(ToastrContext);
  const [openPasswordExpired, setOpenPasswordExpired] = useState(false);
  const [processingOAuth, setProcessingOAuth] = useState(false);

  const { isLoading, message, code, key } = useSelector((s) => s.resetPassword);
  const {
    isLoading: isLoadingLogin,
    code: codeLogin,
    message: messageLogin,
  } = useSelector((s) => s.login);

  useEffect(() => {
    if (getToken()) {
      location.replace('/dc/authentication');
      return;
    }
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    if (code && state) {
      // Clean URL immediately — prevents double-dispatch from React StrictMode
      window.history.replaceState({}, '', '/dc/login');
      setProcessingOAuth(true);
      dispatch(loginOauthIdaman(code, state));
    }
  }, []);

  useEffect(() => {
    if(!isLoading){
      setToastr({
        visible: (!isLoading && message && code === 200) ? true : false,
        desc: message,
        type: code === 200 ? 'success' : 'danger',
      });
    }
  },[isLoading, message]);

  useEffect(() => {
    if (!isLoadingLogin && codeLogin === 400 && messageLogin.includes('expired')) {
      setOpenPasswordExpired(true);
    }
  }, [isLoadingLogin, codeLogin, messageLogin]);

  const handlePasswordExpired = (username) => {
    dispatch(fetchPasswordExpired(username));
    setOpenPasswordExpired(false);
  };
  const handleCountdownExpired = () => {
    dispatch(clearError());
    setOpenPasswordExpired(false);
  };

  const toggleOpenReminder = () => {
    dispatch(clearError());
    setOpenForgotPassword(false);
    setOpenReminder(!openReminder);
  };

  useEffect(() => {
    if (!isLoading && message && key !== 'expired') {
      if (message.includes('Berhasil')) setOpenForgotPassword(false);
      if (message.includes('5 menit')) toggleOpenReminder();
    }
    if (key === 'expired' && code === 429) {
      setOpenPasswordExpired(true);
    }
  }, [isLoading, message, code]);

  useEffect(() => {
    if (processingOAuth && !isLoadingLogin && messageLogin) {
      setProcessingOAuth(false);
      setToastr({
        visible: true,
        desc: messageLogin,
        type: 'danger',
      });
      dispatch(clearErrorLogin());
    }
  }, [processingOAuth, isLoadingLogin, messageLogin]);

  const handleLoginIdaman = async () => {
    const state = generateState();
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = await generateCodeChallenge(codeVerifier);
    setOAuthState(state);
    setCodeVerifier(codeVerifier);
    const url = buildAuthorizeUrl(state, codeChallenge);
    window.location.href = url;
  };

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_KEY}
      scriptProps={{ async: true }}
      useEnterprise={true}
    >
      <Modal
        centered
        onClose={() => {}}
        opened={processingOAuth}
        radius="lg"
        withCloseButton={false}
      >
        <div className={styles['modal-body']}>
          <div className={styles['modal-header']}>
            <svg className={styles['idaman-loader']} viewBox="0 0 50 50">
              <circle className={styles['loader-track']} cx="25" cy="25" fill="none" r="20" strokeWidth="6" />
              <circle className={styles['loader-thumb']} cx="25" cy="25" fill="none" r="20" strokeWidth="6" />
            </svg>
            <Text className={styles['modal-title']}>Masuk dengan Akun IdAMan</Text>
          </div>
          <Text className={styles['modal-subtitle']}>Mohon tunggu beberapa saat...</Text>
        </div>
      </Modal>
      <div className={styles.root}>
        <div>
          <Card className={styles['card-login']}>
            <div className={styles.icDiv}>
              <LogoMap className={styles['logo-myptm']} />
            </div>
            <h3>DASHBOARD CONSOLE SUBSIDI TEPAT</h3>
            <p>Login dengan email dan kata sandi Anda.</p>
            <LoginForm
              onClearError={() => dispatch(clearErrorLogin())}
              onLoginIdaman={handleLoginIdaman}
              onSubmit={(value) => dispatch(login(value, navigate))}
              toggleOpenForgotPassword={setOpenForgotPassword}
            />
          </Card>
        </div>
        <div>
          <img
            alt="DASHBOARD CONSOLE SUBSIDI TEPAT"
            src="/assets/illu-admin.svg"
          />
        </div>
      </div>
      <ModalForgotPassword
        onClose={setOpenForgotPassword}
        open={openForgotPassword}
      />
      <ModalReminderResetPassword
        onClose={toggleOpenReminder}
        open={openReminder}
      />
      <ModalPasswordExpired
        handleClose={() => setOpenPasswordExpired(false)}
        handleExpired={() => handleCountdownExpired()}
        handleSubmit={(username) => handlePasswordExpired(username)}
        isLoading={isLoadingLogin}
        open={openPasswordExpired}
      />
    </GoogleReCaptchaProvider>
  );
}
